"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Role = void 0;
const specific_entity_1 = require("../../../../abstracts/specific-entity");
/**
 * A specific `Role` client for a particular role.
 * Use this client to query or mutate data for this particular role
 */
class Role extends specific_entity_1.SpecificEntity {
    //TODO swap params order
    constructor(parentEntity, id, debug = false) {
        super(id, parentEntity, debug);
    }
    /**
     * Gets the model for this role
     * @returns
     */
    async get() {
        return (await this.getHttpClient().get(`/role/${this.id}`, { headers: this.getHeaders() })).data;
    }
    /**
     * Update the role. You can edit connected privileges, info attributes and default state
     * @param args `UpdateRoleRequestDto`
     * @returns `RoleResponseDto`
     */
    async update(args) {
        return (await this.getHttpClient().put(`/role/${this.id}`, args, { headers: this.getHeaders() })).data;
    }
    /**
     * Delete the role. Note that this will not delete connected privileges
     */
    async delete() {
        await this.getHttpClient().delete(`/role/${this.id}`, { headers: this.getHeaders() });
    }
}
exports.Role = Role;
